import { render, staticRenderFns } from "./ErrorMessage.vue?vue&type=template&id=c23795ca&"
import script from "./ErrorMessage.vue?vue&type=script&lang=js&"
export * from "./ErrorMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c23795ca')) {
      api.createRecord('c23795ca', component.options)
    } else {
      api.reload('c23795ca', component.options)
    }
    module.hot.accept("./ErrorMessage.vue?vue&type=template&id=c23795ca&", function () {
      api.rerender('c23795ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2S6lyemDqHjrb/JS/comp/ErrorMessage.vue"
export default component.exports